module.exports = __webpack_public_path__ + "img/selected6-min.f2944eb7.png";